<!--
 * @Description: 
 * @Author: xz
 * @Date: 2023-10-31 16:18:05
 * @LastEditTime: 2024-08-22 15:32:17
 * @LastEditors: xz
-->
<template>
  <div id="container">
    <transition>
      <div class="left" v-if="show">
        <div class="upload">
          <!--    :on-change="changeFile"  -->
          <el-upload
            class="upload-demo"
            ref="upload"
            action="#"
            accept=".xlsx,.xls"
            :show-file-list="false"
            :auto-upload="true"
            :on-progress="fileShow"
          >
            <el-button slot="trigger" size="small" type="primary"
              >选取文件</el-button
            >
            <!-- <el-button style="margin-left: 10px" size="small" type="success"
                            @click="submitUpload">上传到服务器</el-button> -->
          </el-upload>
        </div>
        <div class="content">
          <el-table :data="tableData" style="width: 100%; height: 70vh">
            <el-table-column
              prop="c_when"
              label="日期"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="c_what"
              label="文件名"
              width="100"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column label="操作" width="50">
              <template slot-scope="scope">
                <el-button
                  @click="handleClick(scope.row)"
                  type="text"
                  size="small"
                  >查看</el-button
                >
                <el-popconfirm
                  title="你确定需要删除这个文件"
                  @confirm="setdelteFile(scope.row)"
                >
                  <el-button type="text" size="small" slot="reference"
                    >删除</el-button
                  >
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <div class="page">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </transition>
    <div class="tip" :class="show ? 'tip_left' : 'tip_right'">
      <div @click="show = !show" class="hidden_show" title="展示/隐藏文件列表">
        <!-- :class="show ? 'leftInto' : 'rightInfo'"s -->
        <i v-if="!show" class="el-icon-s-fold"></i>
        <i v-if="show" class="el-icon-s-unfold"></i>
      </div>
      <div class="tip_top">
        <div
          class="tip_item"
          :class="active == item ? 'active' : ''"
          v-for="(item, index) in dataList"
          :key="index"
          @click="showPath(item)"
        >
          {{ item }}
        </div>
      </div>
      <div class="tip_bottom">
        <div style="width: 80px">时间选择</div>
        <div>
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="tip_button">
        <el-button type="primary" size="mini" @click="searchPoint"
          >查询</el-button
        >
      </div>
    </div>
    <div class="drawer">
      <el-drawer
        :title="title"
        :visible.sync="drawer"
        direction="rtl"
        :before-close="handleClose"
        custom-class="drawer_right"
      >
        <Float v-if="drawer"></Float>
      </el-drawer>
    </div>

    <div class="tip_pop" v-if="JSON.stringify(nowDataObject) != '{}'">
      <div>
        当前数据量
        <span style="font-size: 20px; font-weight: bold; color: aqua">
          {{ setValue(dataArrayList.length) }}</span
        >
      </div>
      <div class="tip_pop_item">
        <div class="circle">
          <div class="in-circle"></div>
        </div>
        <div>
          时间:<span
            style="color: #3385ff"
            v-if="nowDataObject && nowDataObject.curt"
            >{{ nowDataObject.curt }}</span
          >
        </div>
        <div></div>
        <div>
          在位置<span
            style="color: #3385ff"
            v-if="nowDataObject && nowDataObject.lnt"
            >({{ nowDataObject.lat }},{{ nowDataObject.lnt }})</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  uploadfbfile,
  getFileList,
  getFile,
  getFileReadData,
  deleteFileFp,
  deleteFile,
} from "@/api/float";
import gcoord from "gcoord";
import Float from "../../components/Float.vue";
import { parseTime } from "../../../utils/index.js";
import axios from "axios";
let Map = null;
let graphicLayerRound = null;
let graphicLayer = null;
let randomNum = Math.floor(Math.random() * 101) + 100;
export default {
  components: { Float },
  data() {
    return {
      value1: "", //时间选择
      active: "实时",
      show: false,
      title: "",
      drawer: false, //抽屉
      value: null,
      map: null,
      fileList: [],
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      speed: 100,
      roundList: [],
      navg: null,
      graphicLayer: null,
      point: {},
      show: false,
      //   graphicLayerRound: null,
      pointList: [],
      dataList: ["978297", 978299, "实时"],
      pathEntity: null,
      timeStep: 5,
      lastTime: null,
      car: null,
      nowDataObject: {},
      dataArrayList: [],
      timer: null,
    };
  },
  mounted() {
    this.init();
    this.handleClick({
      c_what: "浮标轨迹.xls",
    });
    this.getList();
    this.startPath();
  },
  methods: {
    setValue(data) {
      return randomNum + data;
    },
    // 关闭抽屉
    handleClose(done) {
      done();
    },
    init() {
      const map = new mars3d.Map("container", {
        scene: {
          center: {
            lat: 29.6285,
            lng: 94.926331,
            alt: 170300,
            heading: 0,
            pitch: -90,
          },
          showSun: true,
          showMoon: true,
          showSkyBox: true,
          showSkyAtmosphere: false, // 关闭球周边的白色轮廓 map.scene.skyAtmosphere = false
          fog: true,
          fxaa: true,
          globe: {
            showGroundAtmosphere: false, // 关闭大气（球表面白蒙蒙的效果）
            depthTestAgainstTerrain: false,
            baseColor: "#546a53",
          },
          cameraController: {
            zoomFactor: 3.0,
            minimumZoomDistance: 1,
            maximumZoomDistance: 50000000,
            enableRotate: true,
            enableZoom: true,
          },
          mapProjection: mars3d.CRS.EPSG3857, // 2D下展示墨卡托投影
          mapMode2D: Cesium.MapMode2D.INFINITE_SCROLL, // 2D下左右一直可以滚动重复世界地图
        },
        control: {
          //   timeline: true,
          baseLayerPicker: false, // basemaps底图切换按钮
          homeButton: false, // 视角复位按钮
          sceneModePicker: false, // 二三维切换按钮
          navigationHelpButton: false, // 帮助按钮
          fullscreenButton: false, // 全屏按钮

          clockAnimate: true, // 时钟动画控制(左下角)
          timeline: true, // 是否显示时间线控件
          contextmenu: { hasDefault: true }, // 右键菜单
        },
        terrain: {
          url: "//data.mars3d.cn/terrain",
          show: false,
        },
        basemaps: [
          {
            name: "天地图影像",
            icon: "img/basemaps/tdt_img.png",
            type: "tdt",
            layer: "img_d",
            // tk: "7f6d901569f737c8226696c0e8eff82c",
            show: true,
          },
        ],
      });
      //   点位图层
      graphicLayer = new mars3d.layer.GraphicLayer({
        allowDrillPick: true, // 如果存在坐标完全相同的图标点，可以打开该属性，click事件通过graphics判断
      });
      //   轨迹图层
      graphicLayerRound = new mars3d.layer.GraphicLayer({
        allowDrillPick: true, // 如果存在坐标完全相同的图标点，可以打开该属性，click事件通过graphics判断
      });
      Map = map;
      map.addLayer(graphicLayer);
      map.addLayer(graphicLayerRound);
      // map.on(mars3d.EventType.click, function (event) {
      //   var point = mars3d.LngLatPoint.fromCartesian(event.cartesian); //转为经纬度
      //   console.log("鼠标单击坐标", point, list);
      // });
      //   时间轴初始化隐藏
      // document.getElementById("timeline").style.display = "none";
      // document.getElementsByClassName("mars3d-clockAnimate")[0].style.display =
      //   "none";
    },
    //上传到服务器
    submitUpload() {
      let formData = new FormData();
      formData.append("action", "pf");
      this.fileList.forEach((item) => {
        formData.append("multipartfiles", item.raw);
      });
      uploadfbfile(formData).then((res) => {
        if (res.data == "ok") {
          this.$message({
            message: "上传成功",
            type: "success",
          });
          this.getList();
          this.currentPage = 1;
        } else {
          this.$message({
            message: "上传失败",
            type: "error",
          });
        }
      });
    },
    fileShow(event, file, fileList) {
      console.log("event, file, fileList", event, file, fileList);
      let formData = new FormData();
      formData.append("action", "pf");
      // this.fileList.forEach((item) => {
      formData.append("multipartfiles", file.raw);
      // });
      uploadfbfile(formData).then((res) => {
        if (res.data == "ok") {
          this.$message({
            message: "上传成功",
            type: "success",
          });
          this.getList();
          this.currentPage = 1;
        } else {
          this.$message({
            message: "上传失败",
            type: "error",
          });
        }
      });
    },
    changeFile(file, fileList) {
      //   this.fileList = fileList;
      // console.log("file, fileList", file, fileList);
      let formData = new FormData();
      formData.append("action", "pf");
      // this.fileList.forEach((item) => {
      formData.append("multipartfiles", file.raw);
      // });
      uploadfbfile(formData).then((res) => {
        if (res.data == "ok") {
          this.$message({
            message: "上传成功",
            type: "success",
          });
          this.getList();
          this.currentPage = 1;
        } else {
          this.$message({
            message: "上传失败",
            type: "error",
          });
        }
      });
    },
    getList() {
      let params = {
        page: this.currentPage,
        size: this.pageSize,
        action: "pf",
      };
      getFileList(params).then((res) => {
        this.tableData = res.data.data;
        this.total = Number(res.data.msg);
      });
    },
    // 改变页数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    handleClick(data) {
      this.pointList = [];
      graphicLayer.clear();
      graphicLayerRound.clear();
      // document.getElementById("timeline").style.display = "none";
      // document.getElementsByClassName("mars3d-clockAnimate")[0].style.display =
      //   "none";
      let params = {
        fileName: data.c_what,
      };
      //   只展示
      try {
        getFile(params).then((res) => {
          let idList = [];
          let result = [];
          res.data.forEach((item) => {
            let pathData = [item[4], item[3], 50];
            // let pathData = gcoord.transform(
            //   [item[4], item[3]], // 经纬度坐标
            //   //   gcoord.Baidu, // 当前坐标系
            //   gcoord.WGS84,
            //   gcoord.GCJ02 // 目标坐标系
            // );
            if (idList.includes(item[1])) {
              result.forEach((i) => {
                if (i.name == item[1]) {
                  i.path.push(pathData);
                  i.data.push(item);
                }
              });
            } else {
              idList.push(item[1]);
              result.push({
                name: item[1],
                path: [[pathData[0], pathData[1], 50]],
                data: [item],
              });
            }
          });
          result.forEach((itme) => {
            if (itme.name == "978299" || itme.name == "978297") {
              this.pointList.push(itme);
              // this.getRoundList(itme);
            }
          });
        });
      } catch (error) {
        this.$message({
          message: "文件格式有误",
          type: "error",
        });
      }
    },
    getRoundList(data) {
      console.log("data", data);
      const graphic = new mars3d.graphic.BillboardEntity({
        position: data.path[data.path.length - 1],
        name: data.name,
        flyTo: true,
        style: {
          label: { text: data.name, pixelOffsetY: -40, color: "#000" },
          clampToGround: true,
          image: require("../../assets/image/iconfontzhongdian.png"),
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        },
        attr: data,
      });
      graphicLayer.addGraphic(graphic);
      let that = this;
      // const graphic1 = new mars3d.graphic.PolylineEntity({
      //     positions: data.path,
      //     style: {
      //         width: 6,
      //         clampToGround: true,
      //         color: Cesium.Color.CYAN,
      //     },
      // });
      // graphicLayer.addGraphic(graphic1);
      graphic.on(mars3d.EventType.click, function (event) {
        // let dom = document.getElementById("tootip");
        // dom.style.top = event.position.y + "px";
        // dom.style.left = event.position.x + "px";
        // that.point = event.graphic.attr;
        // that.show = true;
        that.showRound(event.graphic.attr);
      });
    },
    showRound(data) {
      // (
      //   document.getElementById("timeline") &&
      //   document.getElementById("timeline")
      // ).style.display = "";
      // document.getElementsByClassName("mars3d-clockAnimate")[0].style.display =
      // "";
      graphicLayerRound.clear();
      const property = new Cesium.SampledPositionProperty();
      property.forwardExtrapolationType = Cesium.ExtrapolationType.HOLD;
      property.clampToGround = true;
      let pathEntity = null;
      let start;
      let stop;
      for (let i = 0, len = data.data.length; i < len; i++) {
        const item = data.data[i];
        // console.log("item", item);
        const lng = Number(item[4]); // 经度
        const lat = Number(item[3]); // 纬度
        const height = item[5]; // 高度
        const time = new Date(item[9]).toISOString(); // 时间
        let position = null;
        if (lng && lat) {
          position = Cesium.Cartesian3.fromDegrees(lng, lat, height);
        }
        let juliaDate = null;
        if (time) {
          juliaDate = Cesium.JulianDate.fromIso8601(time);
        }
        if (position && juliaDate) {
          property.addSample(juliaDate, position);
        }
        if (i === 0) {
          start = juliaDate;
        } else if (i === len - 1) {
          stop = juliaDate;
        }
        const graphic = new mars3d.graphic.PointPrimitive({
          position: position,
          name: "轨迹点位",
          attr: item,
          id: item.name,
          style: {
            pixelSize: 8,
            clampToGround: true,
            color: "#000",
          },
          popup: "编号:" + data.name + "<br/>时间:" + time,
        });
        graphicLayerRound.addGraphic(graphic);

        // 创建path对象
      }
      Map.clock.startTime = start.clone();
      Map.clock.currentTime = start.clone();
      Map.clock.stopTime = stop.clone();
      Map.clock.clockRange = Cesium.ClockRange.LOOP_STOP;
      if (Map.controls.timeline && start && stop) {
        Map.controls.timeline.zoomTo(start, stop);
      }
      Map.clock.multiplier = 1000;
      pathEntity = new mars3d.graphic.PathEntity({
        position: property,
        orientation: new Cesium.VelocityOrientationProperty(property),
        // name: "轨迹模型",
        name: this.active,
        flyTo: true,
        style: {
          resolution: 60,
          clampToGround: true,
          leadTime: 0,
          trailTime: 3600 * 100,
          color: "#ff0000",
          width: 3,
        },
        label: {
          text: data.name,
          font_size: 19,
          font_family: "楷体",
          color: Cesium.Color.AZURE,
          outline: true,
          visibleDepth: false,
          outlineColor: Cesium.Color.BLACK,
          outlineWidth: 2,
          clampToGround: true,
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          pixelOffset: new Cesium.Cartesian2(0, -50), // 偏移量
        },
        billboard: {
          scale: 0.1,
          image: require("../../../static/img/float.png"),
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          visibleDepth: false,
          clampToGround: true,
        },
        // popup: data.name,
      });
      graphicLayerRound.addGraphic(pathEntity);
      Map.trackedEntity = pathEntity.entity;
      pathEntity.flyToPoint({
        radius: 100000, // 距离目标点的距离
        heading: 359.9,
        pitch: -90,
        duration: 0.01,
      });
      pathEntity.on(mars3d.EventType.click, (event) => {
        this.drawer = true;
      });
    },
    changeTime(data) {
      let dateString = new Date(data);
      let formattedDate = dateString.toISOString();
      return formattedDate;
    },
    showPath(data) {
      this.active = data;
      console.log("data", data, this.timer);
      if (this.timer) {
        clearInterval(this.timer);
      }
      if (data != "实时") {
        for (let i = 0; i < graphicLayer.graphics.length; i++) {
          let item = graphicLayer.graphics[i];
          if (item.name == data) {
            item.flyTo();
          }
        }
        for (let i = 0; i < this.pointList.length; i++) {
          let point = this.pointList[i];
          if (point.name == data) {
            this.$set(this, "value1", [
              parseTime(point.data[0][9]),
              parseTime(point.data[point.path.length - 1][9]),
            ]);
          }
        }
      }
    },
    searchPoint() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      graphicLayerRound.clear();
      graphicLayer.clear();
      this.nowDataObject = {};
      if (this.active == "") {
        loading.close();
        this.$message({
          message: "请先选择浮漂 ",
          type: "warning",
        });
        return;
      } else if (this.active == "实时") {
        loading.close();
        return this.startPath();
      }

      let params = {
        PhoneNum: this.active,
        // startTime: '2023-09-01 00:00:00',
        // endTime: '2023-12-01 00:00:00'
        startTime: parseTime(this.value1[0]),
        endTime: parseTime(this.value1[1]),
      };
      graphicLayerRound.clear();
      graphicLayer.clear();
      getFileReadData(params).then((res) => {
        console.log("  loading.close();", res);
        const graphic = new mars3d.graphic.BillboardEntity({
          position: [
            res.data[res.data.length - 1][4],
            res.data[res.data.length - 1][3],
            res.data[res.data.length - 1][5],
          ],
          name: this.active,
          flyTo: true,
          style: {
            label: { text: this.active, pixelOffsetY: -40, color: "#000" },
            clampToGround: true,
            image: require("../../assets/image/iconfontzhongdian.png"),
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          },
          attr: res.data[res.data.length - 1],
        });
        graphicLayer.addGraphic(graphic);
        this.showRound(res, graphicLayerRound);
      });
      loading.close();
    },
    startPath() {
      // document.getElementById("timeline").style.display = "";
      // document.getElementsByClassName("mars3d-clockAnimate")[0].style.display =
      //   "";
      Map.clock.multiplier = 10.0;
      let car = new mars3d.graphic.Route({
        name: "router",
        polyline: {
          color: "rgb(0, 217, 0)",
          width: 2,
          clampToGround: true,
          maxDistance: 10000,
        },
        billboard: {
          image: require("../../../static/img/float.png"),
          scale: 0.1,
          alignedAxis: true,
          setHeight: 100,
        },
        maxCacheCount: -1,
        circle: {
          radius: 50,
          materialType: mars3d.MaterialType.CircleWave,
          materialOptions: {
            color: "#ffff00",
            opacity: 0.3,
            speed: 10,
            count: 3,
            gradient: 0.1,
          },
          clampToGround: true,
          show: false,
        },
        label: {
          text: "978299",
          font_size: 19,
          font_family: "楷体",
          color: Cesium.Color.AZURE,
          outline: true,
          visibleDepth: false,
          outlineColor: Cesium.Color.BLACK,
          outlineWidth: 2,
          clampToGround: true,
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          pixelOffset: new Cesium.Cartesian2(0, -50), // 偏移量
        },
        flyTo: true,
        // attr: item
      });
      graphicLayer.addGraphic(car);
      car.on("click", (event) => {
        // console.log("car", event);
        this.drawer = true;
      });
      this.getDataList();
      return;
    },
    getDataList() {
      const date = Cesium.JulianDate.toDate(Map.clock.currentTime);
      const endTime = mars3d.Util.formatDate(date, "yyyy-MM-dd HH:mm:ss");
      // 修改当前时间回退一分钟，因为数据永远是当前时间之前的。
      date.setSeconds(date.getSeconds() - 60);
      Map.clock.currentTime = window.Cesium.JulianDate.fromDate(date);
      // 取数据的时间范围，开始时间
      date.setMinutes(date.getMinutes() - 10); // 初次取一定时间内的数据
      const beginTime = mars3d.Util.formatDate(date, "yyyy-MM-dd HH:mm:ss");
      // 记录最后一次读取数据的时间
      this.lastTime = endTime;
      // 取数据
      this.getPathList(beginTime, endTime);
      // this.updatePath()
      this.timer = setInterval(() => {
        // this.getPathList(beginTime, endTime)
        this.updatePath();
      }, this.timeStep * 1000);
    },
    getPathList(beginTime, endTime) {
      axios
        .get("https://edam.tscon.cn:7778/api9998/getflowcur")
        .then((res) => {
          // console.log(" this.car", res.data.data.lat, res.data.data);
          // this.nowDataObject.push(res.data.data)
          this.nowDataObject = res.data.data;
          this.dataArrayList.unshift(res.data.data);
          this.dataLength++;
          let data = res.data.data;
          graphicLayer.eachGraphic((item) => {
            if (item.name == "router") {
              const point = new mars3d.LngLatPoint(
                res.data.data.lat,
                res.data.data.lnt,
                2800
              );
              item.addDynamicPosition(point, data.curt);
              item.flyToPoint({
                radius: 10000,
              });
            }
          });
        })
        .catch(() => {
          console.log();
        });
    },

    // 后续更新轨迹
    updatePath() {
      const beginTime = this.lastTime;

      const date = new Date(beginTime);
      date.setSeconds(date.getSeconds() + this.timeStep);
      const endTime = mars3d.Util.formatDate(date, "yyyy-MM-dd HH:mm:ss");
      this.lastTime = endTime;

      // 取数据
      this.getPathList(beginTime, endTime);
    },

    // 删除数据
    setdelteFile(data) {
      // console.log("data", data);
      deleteFileFp({ c_id: data.c_id }).then((res) => {
        // console.log("res", res);
        if (res.data.data == "ok") {
          deleteFile({ fileName: data.c_what }).then((res1) => {
            // console.log("res1231", res1);
            if (res1.data) {
              this.$message.success("删除成功");
              this.currentPage = 1;
              this.getList();
            } else {
              this.$message.error("删除失败");
            }
          });
        } else {
          this.$message.error("删除失败");
        }
      });
    },
  },
};
</script>

<style scoped>
.v-enter-active,
.v-leave-active {
  transition: all 0.8s ease;
}

.v-enter,
.v-leave-to {
  transform: translateX(300px);
  opacity: 0;
}

.hidden_show {
  /* position: absolute;
    top: 10px;
    left:470px;
    z-index: 1000; */
}

.hidden_show /deep/ i {
  color: #ccc;
  font-size: 40px;
}

.hidden_show /deep/.el-icon-s-folde {
  width: 40px;
  height: 40px;
  font-size: 40px;
}

#container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.left {
  position: absolute;
  top: 0px;
  left: 0;
  z-index: 1000;
  width: 320px;
  height: calc(100vh - 85px);
  background-color: rgba(0, 0, 0, 0.6);
}

.upload {
  padding: 10px 20px;
}

.tip {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin-bottom: 10px;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 10px;
}

.tip .tip_top {
  display: flex;
  flex-direction: row;
}

.tip .tip_bottom {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
  color: #fff;
}

.tip_bottom /deep/ .el-input__inner {
  background: transparent !important;
}

.tip_bottom /deep/ .el-range-input {
  color: #fff;
  background: transparent !important;
}

.tip_bottom /deep/ .el-range-separator {
  color: #fff;
  background: transparent !important;
}

.tip .tip_button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
  color: #fff;
}

.tip_item {
  margin: 5px;
  padding: 10px;
  background: skyblue;
  border-radius: 8px;
  cursor: pointer;
}

/* 分页 */
.left /deep/ .el-pagination__total {
  color: #fff !important;
}

.left /deep/ .btn-prev {
  color: #fff !important;
  background: transparent;
}

.left /deep/ .btn-next {
  color: #fff !important;
  background: transparent;
}

.left /deep/ .el-pager .number {
  color: #fff !important;
  background: transparent;
}

.left /deep/ .el-pager .active {
  color: #409eff !important;
  background: transparent;
}

.content {
  padding-top: 20px;
  background: transparent;
}

.page {
  margin-top: 20px;
  padding-left: 10px;
}

/* 表格 */
.content /deep/ .el-table,
.content /deep/ .el-table__expanded-cell {
  color: #fff;
  background-color: transparent;
}

/* 表格内背景颜色 */
.content /deep/ .el-table th,
.content /deep/ .el-table tr,
.content /deep/ .el-table td {
  color: #fff;
  background-color: transparent !important;
}

.tootip {
  position: absolute;
  /* top: 0;
  left: 0; */
  z-index: 1999999;
  padding: 20px;
  color: #fff;
  background-color: rgb(0, 0, 0, 0.5);
  border-radius: 10px;
}

.drawer /deep/ .drawer_right {
  position: absolute;
  top: 60px;
  height: calc(100vh - 60px);
  background: rgba(0, 0, 0, 0.5);
}

.active {
  color: #000;
  background: aqua;
  /* color: aqua; */
}

.tip_left {
  animation: toLeft 0.8s;
  animation-fill-mode: forwards;
}

.tip_right {
  animation: toRight 0.8s ease;
  animation-fill-mode: forwards;
}

@keyframes toLeft {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(320px);
  }
}

@keyframes toRight {
  0% {
    transform: translateX(320px);
  }

  100% {
    transform: translateX(0px);
  }
}

.leftInto {
  animation: toLeft 0.8s;
  animation-fill-mode: forwards;
}

.rightInfo {
  animation: toRight 0.8s ease;
  animation-fill-mode: forwards;
}

.circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 10px;
  height: 10px;
  margin-right: 5px;
  background-color: rgba(51, 133, 255, 0.2);
  border-radius: 50%;
}

.in-circle {
  width: 6px;
  height: 6px;
  background-color: #3385ff;
  border-radius: 50%;
}

.tip_pop {
  position: absolute;
  top: 10px;
  left: 50%;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  padding: 14px;
  padding: 10px;
  overflow: auto;
  color: #fff; -content: center; */
  bac ound: rgba(39, 44, 54, .9);

  background: rgba(39, 44, 54, 0.9);
  border-radius: 10px;
  transform: translateX(-50%);
}

.tip_pop_item {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Flotage/index.vue